import { FormFields, FormHeader, FormSection } from '../form';
import { Personnel } from './Personnel';
import { Materials } from './Materials';
import { Vehicles } from './Vehicles';
import { useContext } from 'react';
import { Localization } from '../../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../../context/LanguageSelectorContext';

export const LaborDetails = () => {
    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);

    return (
        <>
            <FormSection>
                <FormHeader>{localization.translate('laborDetails.personnelHeader')}</FormHeader>
                <FormFields className={'space-y-10'}>
                    <Personnel />
                </FormFields>
            </FormSection>
            <FormSection>
                <FormHeader>{localization.translate('laborDetails.materialsHeader')}</FormHeader>
                <FormFields className={'space-y-10'}>
                    <Materials />
                </FormFields>
            </FormSection>
            <FormSection>
                <FormHeader>{localization.translate('laborDetails.vehiclesHeader')}</FormHeader>
                <FormFields className={'space-y-10'}>
                    <Vehicles />
                </FormFields>
            </FormSection>
        </>
    );
};